let language = {
    ORDER_DETAIL_ORDER_REORDER: "Reorder",
    PERSONAL_CENTER_SELECT_ALL: "Select All",
    ORDER_DETAIL_SELECT: "Select",
    ORDER_DETAIL_ITEM: "Item",
    ORDER_DETAIL_PRODUCT_NAME: "Product Name",
    ORDER_DETAIL_UNIT_PRICE: "Unit Price",
    ORDER_DETAIL_QUANTITY: "Quantity",
    ORDER_DETAIL_LINE_AMOUNT: "Subtotal",
    REMODER_MODEL_ORDER_DETAIL_TOTAL: "Total",
    PERSONAL_CENTER_CANCEL: "Cancel",
    PERSONAL_CENTER_REODER: "Reoder",
    ORDER_DETAIL_DOWNLOAD_SPELLOUT_INVOICES: "Download Invoices"
};

export { language };
